import Subscription from './components/Subscription'
import PageWrapper from '../../../../components/PageWrapper'
import Profile from './components/Profile'
import Company from './components/Company'
import React from 'react'
import { useParams } from 'react-router'
import ReleaseInfo from './components/ReleaseInfo'

const AccountOverview = () => {
  const { invitationCode } = useParams<{ invitationCode: string }>()
  console.debug(invitationCode)
  return (
    <PageWrapper isScrollable={true}>
      <Profile />
      <Subscription />
      <Company invitationCode={invitationCode} />
      <ReleaseInfo />
    </PageWrapper>
  )
}

export default AccountOverview
